import type { FilterOption } from '../types.ts';

export const GAMEBUS_SOURCE_ID = 'gamebus' as const;
export const GAMEBUS_WEB_BASE = 'https://gamebus001.cc';
export const GAMEBUS_API_BASE = `${GAMEBUS_WEB_BASE}/api`;
export const GAMEBUS_TAG_FILTER_ID = 'gamebusTagId';

export const GAMEBUS_SORT_OPTIONS = [
  { value: 'last_chapterAt', label: 'Latest' },
  { value: 'views', label: 'Views' },
  { value: 'likes', label: 'Likes' },
] satisfies FilterOption[];

export type GameBusSort = (typeof GAMEBUS_SORT_OPTIONS)[number]['value'];

export interface GameBusTagOption {
  id: string;
  name: string;
  count?: number;
}

export interface GameBusChapter {
  id: string;
  title: string;
  orderIndex: number;
  pageCount?: number;
  createdAt?: number;
}
